import { FormControl, Select } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  minWidth: 0,
  flex: 1,
  margin: 0,
  padding: theme.spacing(0, 0.5),
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#EBEBF7",
  },
  "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
    fontSize: 15,
    lineHeight: "18px",
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    backgroundColor: "#FAFAFF",
    borderColor: "#EBEBF7",
  },
  "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
    zIndex: 9,
    color: "rgba(54, 56, 70, 0.4)",
  },
  "& .MuiSelect-iconOutlined.Mui-disabled": {
    zIndex: 9,
    color: "rgba(54, 56, 70, 0.4)",
  },
  [theme.breakpoints.down("xl")]: {
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
      fontSize: 12,
      lineHeight: "12px",
      minHeight: "auto",
      padding: theme.spacing(1.3, 3, 1.3, 1),
    },
  },
})) as any;
